import { useBoardStore } from "../stores/boardStore";
import { contactsList } from "../stores/contactsStore";

export const fetchRelatedChats = async () => {
    const boardStore = useBoardStore();
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return { data: potentialContacts };
    } catch (e) {
        return e.response;
    }
};

export const getContactTypeName = (contactTypeId) => {
    const typeMap = {
        0: "Groups",
        1: "Vendors",
        2: "Landlords",
        3: "Buyers",
        4: "Tenants",
        5: "Suppliers",
    };
    return typeMap[contactTypeId] || "Others";
};

export const fetchOngoingChats = async () => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return { data: ongoingChats };
    } catch (e) {
        return e.response;
    }
};

export const closeConversation = async (contactGroup) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        ongoingChats = ongoingChats.filter(
            (contactGroupx) => contactGroupx.contact_group_id !== contactGroup.contact_group_id,
        );
        return { data: ongoingChats };
    } catch (e) {
        return e.response;
    }
};

export const getConversation = async () => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        return { data: chats };
    } catch (e) {
        return e.response;
    }
};

export const sendMessage = async (message) => {
    if (!message) return;
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        const newMessage = {
            message: message,
            is_read: true,
            is_agent: true,
            time: String(new Date()),
        };
        chats.push(newMessage);

        return { data: chats };
    } catch (e) {}
};

// [todo]: Remove everything below
const potentialContacts = {
    Landlord: [
        {
            contact_group_id: 1,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "thomas.harris@mail.com",
                    title: "23",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07777 889900",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "0117 789 0123",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: "BS1 5HX",
                    last_name: "Harris",
                    first_name: "Thomas",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 19,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "32",
                    address_line_2: "Ash Terrace",
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },

        {
            contact_group_id: 2,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "oliver.jones@mail.com",
                    title: "23",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07111 223344",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "020 7123 4567",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: "W1T 3BL",
                    last_name: "Jones",
                    first_name: "Oliver",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 7,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "1",
                    address_line_2: "Maple Street",
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "oliver.jones@mail.com",
                    title: "23",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07111 223344",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "020 7123 4567",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: "W1T 3BL",
                    last_name: "Jones",
                    first_name: "Oliver",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 7,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "1",
                    address_line_2: "Maple Street",
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "oliver.jones@mail.com",
                    title: "23",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07111 223344",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "020 7123 4567",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: "W1T 3BL",
                    last_name: "Jones",
                    first_name: "Oliver",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 7,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "1",
                    address_line_2: "Maple Street",
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "oliver.jones@mail.com",
                    title: "23",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07111 223344",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "020 7123 4567",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: "W1T 3BL",
                    last_name: "Jones",
                    first_name: "Oliver",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 7,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "1",
                    address_line_2: "Maple Street",
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "michael.johnson@mail.com",
                    title: "24",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07567 890123",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "020 7123 4567",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: "NW8 9AY",
                    last_name: "Johnson",
                    first_name: "Michael",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 8,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "22",
                    address_line_2: "Abbey Road",
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },
        {
            contact_group_id: 3,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "harry.wright@mail.com",
                    title: "23",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07333 445566",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "0161 345 6789",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: "M1 5GD",
                    last_name: "Wright",
                    first_name: "Harry",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 9,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "5",
                    address_line_2: "Oak Lane",
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "sophia.wright@mail.com",
                    title: "24",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07222 334455",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: null,
                    last_name: "Wright",
                    first_name: "Sophia",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 10,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: null,
                    address_line_2: null,
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },

        {
            contact_group_id: 4,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "mia.white@mail.com",
                    title: "24",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07666 778899",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "0131 678 9012",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: "EH3 9AB",
                    last_name: "White",
                    first_name: "Mia",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 11,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "45",
                    address_line_2: "Birch Road",
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },

        {
            contact_group_id: 14,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "mia.white@mail.com",
                    title: "24",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07666 778899",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "0131 678 9012",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: "EH3 9AB",
                    last_name: "White",
                    first_name: "Mia",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 11,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "45",
                    address_line_2: "Birch Road",
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },
        {
            contact_group_id: 16,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "mia.white@mail.com",
                    title: "24",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07666 778899",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "0131 678 9012",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: "EH3 9AB",
                    last_name: "White",
                    first_name: "Mia",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 11,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "45",
                    address_line_2: "Birch Road",
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },
        {
            contact_group_id: 18,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "mia.white@mail.com",
                    title: "24",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07666 778899",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "0131 678 9012",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: "EH3 9AB",
                    last_name: "White",
                    first_name: "Mia",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 11,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "45",
                    address_line_2: "Birch Road",
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },

        {
            contact_group_id: 17,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "mia.white@mail.com",
                    title: "24",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07666 778899",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "0131 678 9012",
                            },
                        },
                    ],
                    country: null,
                    nrl_tax: null,
                    photo_id: null,
                    postcode: "EH3 9AB",
                    last_name: "White",
                    first_name: "Mia",
                    nrl_number: null,
                    vat_number: null,
                    contacts_id: 11,
                    lead_source: null,
                    company_name: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "45",
                    address_line_2: "Birch Road",
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },
    ],

    Tenant: [
        {
            contact_group_id: 5,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "christopher.lee@example.com",
                    title: "23",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07400 234567",
                            },
                        },
                    ],
                    country: null,
                    photo_id: null,
                    postcode: "M1 4AF",
                    last_name: "Lee",
                    first_name: "Christopher",
                    vat_number: null,
                    contacts_id: 30,
                    lead_source: null,
                    company_name: null,
                    move_in_date: null,
                    annual_salary: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "101 Corporate Avenue",
                    address_line_2: null,
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    employment_status: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },
        {
            contact_group_id: 6,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "james.anderson@example.com",
                    title: "23",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07400 345678",
                            },
                        },
                    ],
                    country: null,
                    photo_id: null,
                    postcode: "N1 2BC",
                    last_name: "Anderson",
                    first_name: "James",
                    vat_number: null,
                    contacts_id: 28,
                    lead_source: null,
                    company_name: null,
                    move_in_date: null,
                    annual_salary: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "23 Oak Street",
                    address_line_2: null,
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    employment_status: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "s.anderson@example.com",
                    title: "24",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07400 890123",
                            },
                        },
                    ],
                    country: null,
                    photo_id: null,
                    postcode: "N1 2BC",
                    last_name: "Anderson",
                    first_name: "Sophie",
                    vat_number: null,
                    contacts_id: 29,
                    lead_source: null,
                    company_name: null,
                    move_in_date: null,
                    annual_salary: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "23 Oak Street",
                    address_line_2: null,
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    employment_status: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },
        {
            contact_group_id: 8,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "olivia.martin@example.com",
                    title: "24",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07400 789012",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "020 7345 6789",
                            },
                        },
                    ],
                    country: null,
                    photo_id: null,
                    postcode: "B1 2JL",
                    last_name: "Martin",
                    first_name: "Olivia",
                    vat_number: null,
                    contacts_id: 27,
                    lead_source: null,
                    company_name: null,
                    move_in_date: null,
                    annual_salary: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "25 Meadow Lane",
                    address_line_2: null,
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    employment_status: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },
        {
            contact_group_id: 7,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_w",
                    email: "alitenant@gmail.com",
                    title: null,
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: null,
                                code: null,
                                phoneNumber: "+44054 5454 5455",
                            },
                        },
                    ],
                    country: null,
                    photo_id: null,
                    postcode: null,
                    last_name: null,
                    first_name: "Ali tenant",
                    vat_number: null,
                    contacts_id: 32,
                    lead_source: null,
                    company_name: null,
                    move_in_date: null,
                    annual_salary: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: null,
                    address_line_2: null,
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    employment_status: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },

        {
            contact_group_id: 25,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "christopher.lee@example.com",
                    title: "23",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07400 234567",
                            },
                        },
                    ],
                    country: null,
                    photo_id: null,
                    postcode: "M1 4AF",
                    last_name: "Lee",
                    first_name: "Christopher",
                    vat_number: null,
                    contacts_id: 30,
                    lead_source: null,
                    company_name: null,
                    move_in_date: null,
                    annual_salary: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "101 Corporate Avenue",
                    address_line_2: null,
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    employment_status: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },
        {
            contact_group_id: 26,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "james.anderson@example.com",
                    title: "23",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07400 345678",
                            },
                        },
                    ],
                    country: null,
                    photo_id: null,
                    postcode: "N1 2BC",
                    last_name: "Anderson",
                    first_name: "James",
                    vat_number: null,
                    contacts_id: 28,
                    lead_source: null,
                    company_name: null,
                    move_in_date: null,
                    annual_salary: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "23 Oak Street",
                    address_line_2: null,
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    employment_status: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "s.anderson@example.com",
                    title: "24",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07400 890123",
                            },
                        },
                    ],
                    country: null,
                    photo_id: null,
                    postcode: "N1 2BC",
                    last_name: "Anderson",
                    first_name: "Sophie",
                    vat_number: null,
                    contacts_id: 29,
                    lead_source: null,
                    company_name: null,
                    move_in_date: null,
                    annual_salary: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "23 Oak Street",
                    address_line_2: null,
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    employment_status: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },
        {
            contact_group_id: 28,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_q",
                    email: "olivia.martin@example.com",
                    title: "24",
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: "1",
                                code: null,
                                phoneNumber: "07400 789012",
                            },
                        },
                        {
                            phone: {
                                type: "2",
                                code: null,
                                phoneNumber: "020 7345 6789",
                            },
                        },
                    ],
                    country: null,
                    photo_id: null,
                    postcode: "B1 2JL",
                    last_name: "Martin",
                    first_name: "Olivia",
                    vat_number: null,
                    contacts_id: 27,
                    lead_source: null,
                    company_name: null,
                    move_in_date: null,
                    annual_salary: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: "25 Meadow Lane",
                    address_line_2: null,
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    employment_status: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },
        {
            contact_group_id: 27,
            contacts: [
                {
                    lat: null,
                    lng: null,
                    town: null,
                    badge: "name_icon_w",
                    email: "alitenant@gmail.com",
                    title: null,
                    county: null,
                    phone1: [
                        {
                            phone: {
                                type: null,
                                code: null,
                                phoneNumber: "+44054 5454 5455",
                            },
                        },
                    ],
                    country: null,
                    photo_id: null,
                    postcode: null,
                    last_name: null,
                    first_name: "Ali tenant",
                    vat_number: null,
                    contacts_id: 32,
                    lead_source: null,
                    company_name: null,
                    move_in_date: null,
                    annual_salary: null,
                    selected_data: null,
                    account_number: null,
                    address_line_1: null,
                    address_line_2: null,
                    address_line_3: null,
                    company_number: null,
                    uk_bank_details: null,
                    proof_of_address: null,
                    account_sort_code: null,
                    employment_status: null,
                    full_bank_details: null,
                    account_payee_name: null,
                    simple_bank_details: null,
                },
            ],
        },
    ],
};

let ongoingChats = [];

const chats = [
    {
        message:
            "Ok the sink is fixed I’ve added a new seal but I would recommend changing the sink soon. See bellow the repair",
        is_read: true,
        is_agent: false,
        time: String(new Date()),
    },
    {
        message: "Thats perfect I’ll be there",
        is_read: true,
        is_agent: true,
        time: String(new Date()),
    },
    {
        message: "Ok the sink is fixed I’ve added a new seal but I would recommend changing.",
        is_read: true,
        is_agent: false,
        time: String(new Date()),
    },
    {
        message: "I'll remember this. Thanks",
        is_read: true,
        is_agent: true,
        time: String(new Date()),
    },
];
